const mammoth = require("mammoth");
const DOMPurify = require("dompurify");

function sanitizeDocxHtml(html) {
  if (typeof html !== "string") {
    return "";
  }
  if (!DOMPurify.isSupported) {
    return "";
  }
  return DOMPurify.sanitize(html);
}

function scheduleDocxHtmlMount(elementId, html) {
  const safeHtml = sanitizeDocxHtml(html);
  const paint = () => {
    const el = document.getElementById(elementId);
    if (el) {
      el.innerHTML = safeHtml;
    }
  };
  requestAnimationFrame(() => {
    requestAnimationFrame(paint);
  });
}

const DocxPreviewPort = {
  add: function (app) {
    if (app.ports.mountDocxHtml) {
      app.ports.mountDocxHtml.subscribe(({ elementId, html }) => {
        if (elementId && typeof html === "string") {
          scheduleDocxHtmlMount(elementId, html);
        }
      });
    }

    if (app.ports.clearDocxMount) {
      app.ports.clearDocxMount.subscribe((elementId) => {
        if (!elementId) {
          return;
        }
        const el = document.getElementById(elementId);
        if (el) {
          el.replaceChildren();
        }
      });
    }

    if (app.ports.convertDocxFromUrl) {
      app.ports.convertDocxFromUrl.subscribe(async ({ requestId, url }) => {
        if (!app.ports.docxPreviewHtmlResult) {
          return;
        }
        const fail = () => app.ports.docxPreviewHtmlResult.send({ requestId, ok: false, html: null });
        try {
          const res = await fetch(url);
          if (!res.ok) {
            fail();
            return;
          }
          const arrayBuffer = await res.arrayBuffer();
          const result = await mammoth.convertToHtml({ arrayBuffer });
          const rawHtml = result.value || "";
          app.ports.docxPreviewHtmlResult.send({
            requestId,
            ok: true,
            html: sanitizeDocxHtml(rawHtml),
          });
        } catch {
          fail();
        }
      });
    }
  },
};

module.exports = DocxPreviewPort;
